export enum GreenCheckAwsEnvironmentName {
  INTEGRATION = 'integration',
  STAGING = 'staging',
  PROD = 'prod',
  DEMO = 'demo',
  QA = 'qa',
  DR = 'dr'
}
